import { render, staticRenderFns } from "./editGiftGalleryModel.vue?vue&type=template&id=7c018732&scoped=true"
import script from "./editGiftGalleryModel.vue?vue&type=script&lang=js"
export * from "./editGiftGalleryModel.vue?vue&type=script&lang=js"
import style0 from "./editGiftGalleryModel.vue?vue&type=style&index=0&id=7c018732&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c018732",
  null
  
)

export default component.exports